import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ThemeInput from "../components/ThemeComponent/ThemeInput";
import { ThemeButton } from "../components/ThemeComponent/ThemeButtons";
import {
  AuthHeadingText,
  TextBasic,
} from "../components/ThemeComponent/ThemeText";
import { validation, validationText, WEB_ROUTES } from "../utils/constants.js";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { useLoginUserMutation } from "../Redux/services/userAuthApi.js";
import { errorToast, success } from "../utils/helpers.js";
import { storeToken } from "../Redux/services/localStorageService.js";
import ThemeSpinner from "../components/ThemeComponent/ThemeSpinner";

export default function Login() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [showpassword, setShowPassword] = useState(false);

  const [loginUser, { isLoading }] = useLoginUserMutation();

  const handleForgotPasswordClick = () => {
    console.log("called");
  };

  const handleLogin = async (data) => {
    console.log(data);
    data["device_type"] = "android";
    data["device_token"] = "234";
    try {
      const response = await loginUser(data);

      if (response.data.code === 200) {
        console.log("login successful");
        storeToken(response.data.data.api_token);
        success(response?.data?.message || "login successfully");
        if (response.data.data?.user_type === "CLIENT") {
          navigate(WEB_ROUTES.staff);
        } else if (response.data.data?.user_type === "STAFF") {
          navigate(WEB_ROUTES.task);
        } else {
          navigate("/dashboard");
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      } else {
        errorToast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className="auth w-100">
      <TextBasic text="Hello there," classes="w-100 mt-1" />
      <AuthHeadingText text="Welcome Back" classes="w-100 mb-2" />

      <Form onSubmit={handleSubmit(handleLogin)}>
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"email"}
          className={""}
          placeholder={"Email Address"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />
        <div className="password-input mb-3">
          <ThemeInput
            name="password"
            errors={errors}
            control={control}
            type={!showpassword ? "password" : "text"}
            className={"mt-3"}
            placeholder={"Password"}
            rules={{
              required: {
                value: true,
                message: validationText.passwordRequired,
              },
              maxLength: {
                value: validation.passwordMax,
                message: validationText.passwordMax,
              },
              minLength: {
                value: validation.passwordMin,
                message: validationText.passwordMin,
              },
            }}
          />
          <span
            className="icon cursor"
            onClick={() => setShowPassword(!showpassword)}
          >
            {showpassword ? (
              <VscEyeClosed size={20} className="text-black" />
            ) : (
              <VscEye size={20} className="text-black" />
            )}
          </span>
        </div>

        <div className="d-flex">
          <TextBasic
            className={`ms-auto cursor forgetPassword fw-semibold`}
            text="Forget Password"
            onClick={() => navigate("/forgot-password")}
          />
        </div>

        <ThemeButton
          text={isLoading ? <ThemeSpinner /> : "Login"}
          className="mt-4 mb-2 fw-bold w-100 mt-3"
          type="submit"
          onClick={handleSubmit(handleLogin)}
        />
      </Form>
    </div>
  );
}
